// 이용약관·개인정보 처리방침 초안 — 보관 기간·위탁·국외 이전은 코드·업체 공식 문서 기준으로 채웠지만 법률 검토 전이다.

import { SUPPORT_EMAIL } from "@buildpy/core/lib/support-email";
import { AUDIT_RETENTION_DAYS, ORG_RETENTION_TEXT, SUSPEND_READ_ONLY_DAYS } from "@buildpy/core/modules/org/status";

export const OPERATOR_NAME = "buildpy";
export const CONTACT_EMAIL = SUPPORT_EMAIL;
export const PRIVACY_OFFICER = `개인정보 보호 담당 · ${CONTACT_EMAIL}`;
export const LEGAL_DRAFT_NOTICE = "법률 검토 전 초안입니다. 문구는 검토 뒤 바뀔 수 있습니다.";
export const LEGAL_EFFECTIVE_DATE = "시행일 2026년 10월 29일";
export const BACKUP_RETENTION_TEXT = "백업은 30일 뒤 자동 삭제됩니다.";
// 운영자 감사 기록(admin_audit)만 파기 뒤 1년 — 다른 자료엔 1년 보관이 없다(`0116`).
export const AUDIT_RETENTION_TEXT = `운영자 감사 기록(운영자 조치와 대표의 해지 기록)은 분쟁에 대비해 조직 파기 후 ${AUDIT_RETENTION_DAYS}일(1년) 보관하고, 그 뒤 기록에 든 이용자(대표·멤버) 이메일과 메모·사유 글을 지웁니다. 조치한 운영자의 이메일은 남습니다.`;

export interface LegalArticle {
  title: string;
  body: readonly string[];
}

export interface LegalDoc {
  title: string;
  lead: string;
  articles: readonly LegalArticle[];
}

export const TERMS_DOC: LegalDoc = {
  title: "이용약관",
  lead: `이 약관은 ${OPERATOR_NAME}(빌드파이, 이하 「운영자」)가 제공하는 buildpy 서비스를 쓰는 조건과 절차를 정합니다.`,
  articles: [
    { title: "제1조 목적", body: ["이 약관은 운영자와 서비스를 쓰는 시공사(이하 「회원사」) 사이의 권리·의무와 책임을 정합니다."] },
    {
      title: "제2조 서비스",
      body: [
        "운영자는 인테리어 시공사가 문의, 견적, 계약, 시공, 준공 기록을 관리하고 고객에게 링크로 보여 주는 기능을 제공합니다.",
        "무료 요금제의 사진 저장·알림톡 한도는 요금제 화면에 적힌 대로이며, 한도를 넘어도 서비스를 막지 않고 알려 드립니다. 한도를 줄일 때는 30일 전에 알립니다.",
      ],
    },
    {
      title: "제3조 가입과 계정",
      body: [
        "가입은 이메일 확인을 마친 뒤 회사 정보를 넣고, 이 약관에 동의하고 개인정보 처리방침을 확인하면 끝납니다. 만 14세 미만은 가입할 수 없습니다.",
        "무료 시공사는 계정 하나에 하나만 만들 수 있습니다.",
        "회원사는 계정과 비밀번호를 안전하게 관리하며, 초대한 멤버의 행위에도 책임을 집니다.",
      ],
    },
    {
      title: "제4조 회원사의 자료",
      body: [
        "회원사가 올린 고객 정보, 견적, 계약서, 사진의 권리와 책임은 회원사에 있습니다.",
        "회원사는 운영자가 서비스를 제공하는 데 필요한 범위에서 그 자료를 저장, 복제, 전송, 표시하도록 허락합니다.",
        "회원사는 고객의 개인정보를 받을 때 법령이 정한 근거를 갖추고 고객에게 알려야 합니다.",
        "대표 계정은 설정에서 자료를 언제든 내려받을 수 있습니다.",
      ],
    },
    {
      title: "제5조 고객 개인정보의 처리 위탁",
      body: [
        "회원사는 고객 개인정보의 저장, 화면 표시, 고객 링크 제공, 알림 발송을 운영자에게 맡기며, 이 조항이 그 위탁 문서가 됩니다.",
        "운영자는 맡은 업무 밖으로 고객 개인정보를 쓰거나 제3자에게 주지 않고, 개인정보 처리방침 10절의 안전성 확보 조치를 지킵니다.",
        "회원사는 운영자가 개인정보 처리방침 6절의 업체에 처리를 다시 맡기는 데(재위탁) 동의합니다. 업체를 바꾸거나 더하면 미리 알립니다.",
        "위탁이 끝나면 운영자는 제8조의 보관 기간이 지난 뒤 고객 개인정보를 지웁니다.",
      ],
    },
    {
      title: "제6조 금지 행위",
      body: [
        "남의 정보로 가입하거나, 법령을 어기는 자료를 올리거나, 서비스를 불법적인 목적으로 써서는 안 됩니다.",
        "서비스에 무리를 주거나 보안을 뚫으려 해서는 안 됩니다.",
        "고객의 동의나 법적 근거 없이 개인정보를 올리거나 써서는 안 됩니다.",
        "공정 표준 위키·Q&A에 시공 단가·자재 가격·원가 같은 금액 정보를 올려서는 안 됩니다. 신고된 글은 운영자가 확인한 뒤 알리지 않고 지울 수 있습니다. 반복하면 제9조에 따라 이용을 정지할 수 있습니다.",
      ],
    },
    {
      title: "제7조 요금",
      body: ["지금은 무료 요금제만 있습니다. 유료 요금제가 생기면 시작하기 30일 전에 알리고, 회원사가 고르지 않으면 무료 요금제가 그대로 이어집니다."],
    },
    {
      title: "제8조 탈퇴와 탈퇴 후 자료 처리",
      body: [
        `회원사는 언제든 탈퇴할 수 있습니다. 대표가 설정에서 직접(또는 메일) 합니다 — 설정 > 회사의 「조직 탈퇴」에서 조직 이름과 비밀번호를 다시 넣거나, 대표 계정의 메일로 고객센터(${CONTACT_EMAIL})에 요청하세요.`,
        "탈퇴(해지)하면 바로 모든 기능과 고객 링크가 막힙니다.",
        `${ORG_RETENTION_TEXT}.`,
        `${BACKUP_RETENTION_TEXT} 지운 자료는 되살릴 수 없으니 탈퇴 전에 내려받아 두세요.`,
      ],
    },
    {
      title: "제9조 이용 정지와 해지",
      body: [
        "회원사가 요금을 내지 않거나, 이 약관을 어기거나, 서비스를 불법적으로 쓰면 운영자는 사유를 알린 뒤 이용을 정지하거나 계약을 해지할 수 있습니다.",
        `이용 정지 뒤 ${SUSPEND_READ_ONLY_DAYS}일 동안은 조회만 할 수 있고, 그 뒤에는 막힙니다. 해지하면 제8조처럼 처리합니다.`,
        "법령 위반이 명백하거나 다른 이용자에게 급한 피해가 생기면 먼저 막고 바로 알립니다.",
      ],
    },
    { title: "제10조 서비스 중단", body: ["운영자는 점검·장애 때 서비스를 잠시 멈출 수 있으며, 미리 알릴 수 있으면 알립니다."] },
    {
      title: "제11조 책임의 한계",
      body: [
        "운영자는 회원사와 고객 사이의 공사 계약 내용과 이행에 책임지지 않습니다.",
        "운영자는 천재지변, 회원사의 잘못, 운영자가 막을 수 없는 외부 서비스 장애로 생긴 손해에 책임지지 않습니다. 운영자에게 고의나 중대한 과실이 있으면 그렇지 않습니다.",
      ],
    },
    {
      title: "제12조 약관 변경",
      body: [
        "약관을 바꾸면 시행 7일 전(회원사에 불리하면 30일 전)에 서비스 화면과 메일로 알립니다.",
        "바뀐 약관에 동의하지 않으면 시행 전에 탈퇴할 수 있습니다. 알림에 이 내용을 분명히 적었는데도 시행일까지 거부 의사가 없으면 동의한 것으로 봅니다.",
      ],
    },
    { title: "제13조 분쟁 해결", body: ["이 약관은 대한민국 법을 따르며, 분쟁은 민사소송법에 따른 관할 법원에서 해결합니다."] },
    { title: "제14조 문의", body: [`서비스 문의는 고객센터(${CONTACT_EMAIL})로 받습니다.`] },
  ],
};

export const PRIVACY_DOC: LegalDoc = {
  title: "개인정보 처리방침",
  lead: `${OPERATOR_NAME}(빌드파이, 이하 「운영자」)는 buildpy 서비스를 제공하면서 처리하는 개인정보를 아래와 같이 다룹니다.`,
  articles: [
    {
      title: "1. 처리 목적과 근거",
      body: [
        "가입과 서비스 제공 계약을 이행하는 데 필요한 정보는 동의 없이 처리합니다(개인정보 보호법 제15조 제1항 제4호): 가입 확인, 로그인, 시공사 계정 운영, 견적서·계약서에 회사 정보 넣기, 사용량·한도 안내, 문의 응대.",
        "부정 가입·남용 방지, 보안 사고 대응, 오류 확인은 서비스를 안전하게 제공하려고 동의 없이 처리합니다(같은 항 제6호).",
        "가입할 때 받는 「개인정보 처리방침 확인」은 이 방침을 읽었다는 확인입니다. 운영자는 동의를 따로 받아야 하는 처리(마케팅 메일 등)를 하지 않습니다.",
        "이용 통계는 개인을 알아볼 수 없게 묶어서만 씁니다.",
      ],
    },
    {
      title: "2. 처리하는 항목",
      body: [
        "가입: 이름, 이메일, 비밀번호(복원할 수 없게 바꿔 저장).",
        "시공사 만들기: 상호, 대표자명, 대표 전화, 간편접수 주소 / 선택 — 담당자 휴대전화, 주소, 사업자등록번호, 건설업 등록번호, 직원 수, 공사 종류, 월 현장 수, 알게 된 경로.",
        "초대받은 멤버: 이름, 이메일, 비밀번호(복원할 수 없게 바꿔 저장).",
        "약관 동의·처리방침 확인 기록: 문서 종류, 판, 시각.",
        "출시 알림 신청: 받는 분 이름, 이메일, 필요한 기능, 메모.",
        "의견 보내기: 보낸 내용, 보낸 화면 / 고객센터 문의: 보낸 메일 내용과 회신 주소.",
        "자동 수집: 접속 IP, 브라우저 정보, 접속 일시, 오류 기록.",
      ],
    },
    {
      title: "3. 보유 기간",
      body: [
        "가입 정보와 시공사 자료는 탈퇴(해지)할 때까지 보관합니다.",
        `${ORG_RETENTION_TEXT}.`,
        `데이터베이스는 매일 백업합니다. ${BACKUP_RETENTION_TEXT}`,
        "가입 남용 방지에 쓰는 접속 IP는 제한 시간이 지나면 자동으로 정리됩니다.",
        "오류 기록은 최대 90일 보관 후 자동 삭제됩니다. 메일 발송 기록은 30일 뒤 지워집니다.",
        AUDIT_RETENTION_TEXT,
        "법령이 보관을 정한 정보는 그 기간 동안 다른 정보와 분리해 보관합니다.",
      ],
    },
    {
      title: "4. 파기 절차와 방법",
      body: [
        "보유 기간이 끝나거나 처리 목적을 이룬 정보는 지체 없이 지웁니다.",
        `전자 파일은 되살릴 수 없게 지웁니다. ${BACKUP_RETENTION_TEXT}`,
        "법령에 따라 남겨야 하는 정보는 다른 정보와 분리해 그 기간만 보관한 뒤 지웁니다.",
      ],
    },
    {
      title: "5. 제3자 제공",
      body: ["운영자는 개인정보를 제3자에게 제공하지 않습니다. 법령에 근거가 있거나 수사기관이 적법한 절차로 요구하는 경우만 예외입니다."],
    },
    {
      title: "6. 처리 위탁",
      body: [
        "Supabase Pte. Ltd.: 데이터베이스 저장, 로그인·인증.",
        "Cloudflare, Inc.: 서버 운영, 사진·파일 저장, 네트워크 전송.",
        "Plus Five Five, Inc.(Resend): 가입 확인·비밀번호 재설정·사용량 안내 메일 발송.",
        "Functional Software, Inc.(Sentry): 오류 기록 수집·분석.",
        "GitHub, Inc.: 데이터베이스 백업 보관.",
        "위탁 업무나 업체가 바뀌면 이 방침에 바로 반영합니다.",
      ],
    },
    {
      title: "7. 국외 이전",
      body: [
        "서비스 제공 계약을 이행하려고 아래 국외 업체에 개인정보 처리를 맡기고 보관합니다(개인정보 보호법 제28조의8 제1항 제3호).",
        "이전 시기와 방법: 서비스를 이용할 때마다 네트워크(HTTPS)로 보냅니다. 백업은 매일 한 번 보냅니다.",
        "Supabase Pte. Ltd.(싱가포르 · privacy@supabase.com) — 목적: 데이터베이스 저장, 로그인 · 항목: 2절 전체 · 저장 위치: 대한민국(서울) · 보유: 3절 기간까지.",
        "Cloudflare, Inc.(미국 · dpo@cloudflare.com) — 목적: 서버 운영, 사진·파일 저장 · 항목: 2절 전체와 사진 · 처리 위치: 전 세계 데이터센터, 사진은 아시아·태평양(APAC) · 보유: 3절 기간까지.",
        "Plus Five Five, Inc.(Resend · 미국 · privacy@resend.com) — 목적: 메일 발송 · 항목: 받는 사람 이름, 이메일, 메일 내용 · 발송 위치: 일본(도쿄) · 보유: 30일.",
        "Functional Software, Inc.(Sentry · 미국 · compliance@sentry.io) — 목적: 오류 확인 · 항목: 오류 기록, 브라우저 정보, 접속 경로(토큰·쿠키는 지워서 보냄) · 처리 위치: 미국 · 보유: 최대 90일 보관 후 자동 삭제.",
        "GitHub, Inc.(미국 · privacy@github.com) — 목적: 데이터베이스 백업 보관 · 항목: 데이터베이스 전체 · 처리 위치: 미국 · 보유: 30일 뒤 자동 삭제.",
        `국외 이전을 원하지 않으면 고객센터(${CONTACT_EMAIL})로 탈퇴를 요청해 거부할 수 있습니다. 이 업체들 없이는 서비스를 제공할 수 없어, 거부하면 이용이 끝납니다.`,
      ],
    },
    {
      title: "8. 회원사의 고객 정보",
      body: [
        "회원사가 올리거나 간편접수·고객 링크로 고객이 직접 입력한 정보(이름, 연락처, 현장 주소, 상담·견적·계약 내용, 사진, 후기)는 회원사가 처리하는 정보이며, 운영자는 회원사의 위탁을 받아 처리합니다.",
        "운영자는 저장, 화면 표시, 고객 링크 제공, 알림 발송, 회원사가 정한 웹훅 주소로 전달만 하고 다른 목적으로 쓰지 않습니다.",
        "고객이 링크에서 계약을 체결하거나 변경공사를 승인하면 체결 증거로 이름, 시각, 접속 IP, 브라우저 정보를 남깁니다.",
        "고객의 열람·정정·삭제 요청은 담당 회원사에 하시면 되고, 운영자에게 오면 회원사에 전달합니다.",
      ],
    },
    {
      title: "9. 쿠키와 브라우저 저장소",
      body: [
        "로그인을 유지하려고 로그인 정보를 브라우저 저장소에 둡니다.",
        "고객 링크에서 본인 확인을 마치면 확인 쿠키를, 견적 편집 화면의 보기 방식은 기능 쿠키에 둡니다.",
        "닫은 안내 띠, 견적 가져오기 열 설정, 작성 중인 초안도 브라우저 저장소에 둡니다.",
        "광고·행태 분석 쿠키는 쓰지 않습니다.",
        "브라우저 설정에서 쿠키와 저장소를 막거나 지울 수 있지만, 그러면 로그인과 고객 링크 확인이 되지 않습니다.",
      ],
    },
    {
      title: "10. 안전성 확보 조치",
      body: [
        "비밀번호는 복원할 수 없게 바꿔 저장하고, 모든 통신은 HTTPS 로 보호합니다.",
        "시공사마다 데이터를 분리해 다른 시공사가 볼 수 없게 하고, 고객 링크는 추측할 수 없는 주소와 시도 횟수 제한으로 보호합니다.",
        "운영 비밀값은 별도 보관소에서 관리하고, 오류 기록·로그에서 토큰·쿠키·이메일을 지우거나 가립니다.",
        "운영자 콘솔은 2단계 인증을 거친 운영자만 들어갈 수 있습니다.",
      ],
    },
    {
      title: "11. 만 14세 미만",
      body: ["buildpy는 시공사 업무용 서비스로 만 14세 미만은 가입할 수 없습니다. 만 14세 미만의 정보가 확인되면 바로 지웁니다."],
    },
    {
      title: "12. 이용자의 권리와 행사 방법",
      body: [
        "언제든 개인정보 열람, 정정, 삭제, 처리 정지를 요청할 수 있습니다.",
        "회사 정보는 설정에서 직접 고칠 수 있습니다.",
        "탈퇴는 대표가 설정에서 직접(또는 메일) 합니다 — 설정 > 회사의 「조직 탈퇴」.",
        `그 밖의 요청과 메일 탈퇴는 ${CONTACT_EMAIL} 로 메일을 보내 주세요. 10일 안에 처리하고 결과를 알려 드립니다.`,
        "법정대리인이나 위임받은 사람을 통해서도 요청할 수 있습니다.",
      ],
    },
    { title: "13. 개인정보 보호책임자", body: [PRIVACY_OFFICER] },
    {
      title: "14. 권익 침해 구제",
      body: ["개인정보분쟁조정위원회(1833-6972, kopico.go.kr), 개인정보침해신고센터(118, privacy.kisa.or.kr), 대검찰청(1301), 경찰청(182)에 상담·신고할 수 있습니다."],
    },
    {
      title: "15. 방침의 변경",
      body: ["이 방침을 바꾸면 시행 7일 전(이용자에게 불리하면 30일 전)부터 이 화면에 알립니다."],
    },
  ],
};
